import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon1",
  "use": "icon-icon1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icon1\"><path d=\"M12 1.234L23.86 21H.14L12 1.234zM2.26 19.8h9.06l-4.264-7.994L2.26 19.8zm5.76-9.6h7.96L12 3.566 8.02 10.2zm8.924 1.606L12.68 19.8h9.06l-4.796-7.994zM8.2 11.4l3.8 7.125 3.8-7.125H8.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol